import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal from "@insite/mobius/Modal";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { css } from "styled-components";

const enum fields {
    ctaType = "ctaType",
    ctaText = "ctaText",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.ctaType]: "button" | "link";
        [fields.ctaText]: string;
    }
}

type Props = OwnProps;

export interface ModalTogglerStyles {
    wrapper?: InjectableCss,
    button?: ButtonPresentationProps,
    link?: LinkPresentationProps,
}

export const modalTogglerStyles: ModalTogglerStyles = {
    wrapper: {
        css: css`
            margin: 20px 0;
        `
    },
    button: {
        variant: "tertiary",
    }
}

const styles = modalTogglerStyles;

const ModalToggler: FC<Props> = ({ id, fields }) => {
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

    const openModalHandler = () => {
        setModalIsOpen(true);
    }

    const closeModalHandler = () => {
        setModalIsOpen(false);
    }

    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                {fields.ctaType === "button" && (
                    <Button onClick={openModalHandler} {...styles.button}>
                        {fields.ctaText}
                    </Button>
                )}
                {fields.ctaType === "link" && (
                    <Link onClick={openModalHandler} {...styles.link}>
                        {fields.ctaText}
                    </Link>
                )}
            </StyledWrapper>
            <Modal isOpen={modalIsOpen} handleClose={closeModalHandler} headline={fields.ctaText}>
                <Zone contentId={id} zoneName="ContentZone" />
            </Modal>
        </>
    )
};

const widgetModule: WidgetModule = {
    component: ModalToggler,
    definition: {
        group: "Basic",
        displayName: "Modal Toggler",
        icon: "Banner",
        fieldDefinitions: [
            {
                name: fields.ctaType,
                fieldType: "General",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Button", value: "button" },
                    { displayName: "Link", value: "link" },
                ],
                defaultValue: "button",
                hideEmptyOption: true,
            },
            {
                name: fields.ctaText,
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "",
            }
        ]
    }
};

export default widgetModule;